import Vue from 'vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { BootstrapVue } from 'bootstrap-vue';

import App from './pages/App.vue'
import {store} from './store';
import router from "./router";

console.log(`Version: ${process.env.VUE_APP_VERSION || '0'}`),

Vue.use(BootstrapVue);

Vue.config.productionTip = false;

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')

